import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import { FrequencyLineChart } from '@ge/components/charts';
import { generateWaveForm } from '@ge/components/charts/frequency-line-chart/mocks';

const WaveFormChart = ({ alignChevronLeft, className, onChevronClick, large, title }) => {
  const data = useRef(generateWaveForm(250, 5));

  return (
    <FrequencyLineChart
      alignChevronLeft={alignChevronLeft}
      className={className}
      data={data.current}
      large={large}
      onChevronClick={onChevronClick}
      title={title}
      xAxisMax={250}
      xInterval={50}
      yInterval={0.5}
    />
  );
};

WaveFormChart.propTypes = {
  alignChevronLeft: PropTypes.bool,
  className: PropTypes.string,
  onChevronClick: PropTypes.func,
  large: PropTypes.bool,
  title: PropTypes.string,
};

WaveFormChart.defaultProps = {
  alignChevronLeft: false,
  className: '',
  onChevronClick: null,
  large: false,
  title: null,
};

export default WaveFormChart;
